<template>
  <div class="con">
    <!--<h1 class="title">CFRA</h1>-->
    <!--<p class="p-title">Certified Family Wealth Adviso</p>-->
    <!--详情-->
    <div class="cfwa-txt" v-html="info.content">

    </div>

    <div class="line"></div>
    <div class="reply" @click="offline" v-if="info.enroll==false">课程报名</div>
    <div class="reply over" v-show="info.enroll==true">已报名</div>

  </div>

</template>

<script>
export default {
  name: 'cfwa',
  data () {
    return {
      info:{},//详情
      courseid:'',//课程id
      // token:'',
    }
  },
  mounted(){
    var _this=this;
    if(_this.getUrlParamURLys("token")){

      if(_this.getUrlParamURLys("type")){
        var token=_this.getUrlParamURLys("token");
        var type=_this.getUrlParamURLys("type");
        this.getinfo(type,token);
      }
    }

  },
  methods:{
    getinfo:function (type,token) {
      var _this=this;
      _this.call_net("POST","/api/app/course/offline",{type:type,token:token},function (data) {
        if(data.code===200){
          _this.info=data.data;
          _this.courseid=data.data.id;
        }else {
          Yeffect.mAlert(data.desc);
        }
      });
    },
    offline:function () {
      var _this=this;
      var id=_this.info.id;
      var price=_this.info.price;
      window.location.href="signUp("+id+","+ price+")";
      // var _this=this;
      // _this.call_net("POST","/api/app/course/enroll",{courseid:_this.courseid,token:_this.token},function (data) {
      //   if(data.code===200){
      //     Yeffect.mAlert("报名成功");
      //   }else {
      //     Yeffect.mAlert(data.desc);
      //   }
      // });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con{
    padding: 0.3rem;
  }
  .con h1.title{
    color: #333;
    font-size: 0.36rem;
    text-align: center;
  }
  .con p.p-title{
    font-size: 0.22rem;
    color: #333;
    text-align: center;
    margin-top: 0.1rem;
  }
  .cfwa-txt{
    margin-top: 0.3rem;
  }
  .cfwa-txt >>> p,.cfwa-txt >>> span,.cfwa-txt{
    font-size: 0.24rem;
    color: #333 !important;
    line-height: 0.48rem;
    font-style: normal !important;
  }
  .cfwa-txt >>> img,.yuan-txt img,.hui-txt img,.fan-txt img{
    display: block;
    width: 100% !important;
    height: auto !important;
    margin: 0.4rem 0;
  }
  .yuan-title,.hui-title,.fan-title{
    margin-top: 0.86rem;
    margin-bottom: 0.5rem;
  }
  .yuan-title img,.hui-title img,.fan-title img{
    display: block;
    width: 100%;
    height: auto;
  }
  .reply{
    position: fixed;
    width: 100%;
    height: 0.97rem;
    line-height: 0.97rem;
    text-align: center;
    background-color: #d7b177;
    bottom: 0;
    left: 0;
    font-size: 0.32rem;
    color: #fff;
  }
  .reply.over{
    background-color: #999999;
  }
  .line{
    height: 0.97rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/cfra.vue